const SITE_NAME = "ARAN TOOLS";

export function withSiteName(title) {
  const normalized = typeof title === "string" ? title.trim() : "";
  if (!normalized) return SITE_NAME;
  const suffix = new RegExp(`(?:\\s*[—–-]\\s*${SITE_NAME})+$`, "i");
  const withoutRepeatedSuffix = normalized.replace(suffix, "").trim();
  return withoutRepeatedSuffix
    ? `${withoutRepeatedSuffix} — ${SITE_NAME}`
    : SITE_NAME;
}
